import { SysMessage as SystemMessage } from "models/user/user";
import { Icon } from "components/icon/Icon";

import "./SysMessage.scss";

type Props = {
  messageInfo: SystemMessage;
};

export default function SysMessage({ messageInfo }: Props) {
  return !messageInfo ||
    messageInfo.message === "" ||
    (messageInfo.validUntil &&
      new Date(messageInfo.validUntil) < new Date()) ? (
    <div></div>
  ) : (
    <div className="wrappercontent">
      <span>
        <Icon name="exclamation-triangle" />
      </span>
      <span>
        &nbsp;
        {messageInfo.message}
      </span>
    </div>
  );
}
